
const STATUS = {
  1: { label: "Rascunho", className: "label-light-primary" },
  2: { label: "Em aberto", className: "label-light-primary" },
  3: { label: "Parcial", className: "label-light-warning" },
  4: { label: "Vencida", className: "label-light-danger" },
  5: { label: "Fechada com venda", className: "label-light-success" },
  6: { label: "Fechada sem venda", className: "label-light-dark" },
  7: { label: "Cancelada", className: "label-light-danger" },
  8: { label: "Com perda/dano", className: "label-light-warning" },
};

export default {
  name: "CondicionalStatusBadge",
  props: {
    status: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    statusConfig() {
      return (
        STATUS[Number(this.status)] || {
          label: "Desconhecido",
          className: "label-light-dark",
        }
      );
    },
    label() {
      return this.statusConfig.label;
    },
    badgeClass() {
      return `label label-lg label-inline font-weight-bold ${this.statusConfig.className}`;
    },
  },
};
